import React from 'react';
import styled from 'styled-components';
import { useFormikContext } from 'formik';

import Autocomplete from 'src/components/Common/AutoComplete';
import { TPostAdInitialValues } from 'src/Types';

/* interface IStyledProps {
  isActive?: boolean;
  loading?: boolean;
  selected?: boolean;
} */
const ListingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;
const TitleWrapper = styled.div`
  margin: 24px 0 12px;
`;
const Title = styled.h1`
  font-size: 25px;
  line-height: 40px;
  font-weight: 700;
  margin: 0;
  color: ${({ theme }) => theme.colors.secondary};
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .MuiInputBase-root {
    width: 100%;
  }
`;

const LocationSelect: React.FunctionComponent = () => {
  const { setFieldValue, values, errors, touched } = useFormikContext<TPostAdInitialValues>();
  return (
    <ListingSection>
      <TitleWrapper>
        <Title>Select location</Title>
      </TitleWrapper>
      <Container>
        {/* <SelectLocation handleSelect={(val) => setFieldValue('location', val)} /> */}
        <Autocomplete
          value={values.address || ''}
          onChangeHandler={(val, placeId) => {
            setFieldValue('address', val);
            setFieldValue('place_id', placeId);
          }}
          withGeoCode
          error={'address' in errors && 'address' in touched}
        />
      </Container>
    </ListingSection>
  );
};

export default LocationSelect;
